import { IconPlaceholderImages24, IconActionReload16 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './OfferGallery.css';

type TOfferGalleryProps = {
  isChatbotReplay: boolean;
  withReload: boolean;
  shareUrl: string;
  photoUrl?: string[];
  onMouseDown(event: React.MouseEvent<HTMLAnchorElement>): void;
  onReload(): void;
  onClick(): void;
};

export const OfferGallery: React.FC<TOfferGalleryProps> = ({
  isChatbotReplay,
  withReload,
  shareUrl,
  photoUrl,
  onMouseDown,
  onReload,
  onClick,
}) => {
  const [imageError, setImageError] = React.useState<boolean[]>(Array(photoUrl?.length || 0).fill(false));

  if (!Array.isArray(photoUrl) || photoUrl.length === 0) {
    return null;
  }

  const displayedImages = isChatbotReplay ? photoUrl.slice(0, 1) : photoUrl.slice(0, 2);
  const allImagesErrored = displayedImages.every((_, index) => imageError[index]);

  const imagesToDisplay = allImagesErrored ? displayedImages.slice(0, 1) : displayedImages;

  return (
    <div
      className={classNames(
        styles['images-container'],
        isChatbotReplay
          ? styles['replay-image']
          : imagesToDisplay.length === 1
            ? styles['single-image']
            : styles['multiple-images'],
      )}
      onClick={onClick}
    >
      {imagesToDisplay.map((url, index) => (
        <a key={index} className={styles['image-container']} onMouseDown={onMouseDown} href={shareUrl} target="_blank">
          {imageError[index] ? (
            <span className={isChatbotReplay ? styles['image-replay-placeholder'] : styles['image-placeholder']}>
              <IconPlaceholderImages24 color="icon-primary-disabled" />
            </span>
          ) : (
            <img
              data-name={`OfferMessage_image_${index}`}
              src={url}
              className={styles['image']}
              alt="Фото объявления"
              onError={() => {
                setImageError(prev => {
                  const newErrorState = [...prev];
                  newErrorState[index] = true;

                  return newErrorState;
                });
              }}
            />
          )}
          {withReload && onReload && (
            <span onClick={onReload} className={styles['image-reload-button']}>
              <IconActionReload16 color="icon-inverted-default" />
            </span>
          )}
        </a>
      ))}
    </div>
  );
};
